<mat-sidenav-container>
  <mat-sidenav #sidenav [opened]="false" mode="over">
    <mat-toolbar color="primary" class="sidenav-header">
      <span>{{ "components.side-nav.menu" | translate }}</span>
      <span class="spacer"></span>
      <button mat-icon-button (click)="sidenav.toggle()" (keydown.enter)="sidenav.toggle()" aria-label="Close menu">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item (click)="goToLeadPool()" (keydown.enter)="goToLeadPool()" tabindex="0">
        <div class="mat-list-item">
          <mat-icon>house</mat-icon>
          <span>{{ "browsertitle./lead-pool" | translate }}</span>
        </div>
      </a>
      <a mat-list-item (click)="changeMediaSettings()" tabindex="0" (keydown.enter)="changeMediaSettings()">
        <div class="mat-list-item">
          <mat-icon>perm_camera_mic</mat-icon>
          {{ "components.side-nav.media-permissions" | translate }}
        </div>
      </a>
      <a mat-list-item>
        <div class="mat-list-item" (click)="changeRouteSettings()" tabindex="0" (keydown.enter)="changeRouteSettings()">
          <mat-icon>route
          </mat-icon>
          {{ "browsertitle./route-settings" | translate }}
        </div>
      </a>
      @if (isAdmin()) {
      <a mat-list-item (click)="goToAdminPanel()" (keydown.enter)="goToAdminPanel()" tabindex="0">
        <div class="mat-list-item">
          <mat-icon>dashboard</mat-icon>
          {{ "browsertitle./admin-panel" | translate }}
        </div>
      </a>
      <a mat-list-item (click)="goToParquetImport()" (keydown.enter)="goToParquetImport()" tabindex="0">
        <div class="mat-list-item">
          <mat-icon>cloud_upload</mat-icon>
          <span>Parquet Import</span>
        </div>
      </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header-section (toggleSideNav)="sidenav.toggle()" />
    <div class="main-content">
      <ng-content></ng-content>
    </div>
    <app-footer />
  </mat-sidenav-content>
</mat-sidenav-container>